export default ({ selectedStyle = {}, disabledWhenFilled = false }) => ({
  formControl: {
    width: '100%'
  },
  select: theme => ({
    ...(theme.isDark ? {} : { backgroundColor: 'white' }),
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      ...(disabledWhenFilled ? { color: 'primary.main' } : '')
    },
    ...selectedStyle
  })
});
